import Header from '../Header'
import Main from './Main'

const HomeScreen = () => {


    return (
        <div>
            <Header />
            <Main />
        </div>
    )
}

export default HomeScreen
